module.exports = __webpack_public_path__ + "img/header-engagementRings070Carat@2x.0559e14.jpg";